export const getChannelId = () => parseInt(process.env.GATSBY_BIGCOMMERCE_CHANNEL ?? "1", 10);
